module.exports = __webpack_public_path__ + "media/images/gallery/solar_systems/craters_off-698a790b0c47154d3485c2f695cc0810.gif";